module.exports = __webpack_public_path__ + "img/post.e3ba2dd9.png";